import React, { useRef, useState } from 'react'
import classes from "./style.module.scss";
import ModalDropdown from '../../component/ModalDropdown';
import CloseIcon from '@mui/icons-material/Close';
import Button from '../../component/Button';
import { FormProvider, useForm } from 'react-hook-form';
import InputBox from '../../component/InputBox';

const RedeemResponseModal = (props) => {
    const { isOpen = false, closePopUp, handleSuccess, onSubmit, value, titleValue } = props
    const selectBoxRef = useRef()
    const formMethods = useForm({
        mode: 'onSubmit',
        defaultValues: {
            email: value,
            title : titleValue
        },
        value,
    });
    const {
        handleSubmit,
        formState: { errors },
        register,
        trigger,
    } = formMethods

    return (
        <>
            <ModalDropdown isOpen={isOpen} closePopUp={closePopUp} selectBoxRef={selectBoxRef}>
                <div className={`${classes.redeemResponseWrapper}`}>
                    <div className={`${classes.modalHeader} flex items-center justify-between`}>
                        <div className={`${classes.modalTitle}`}>Redeem Response</div>
                        <div className={`${classes.modalCloser}`}>
                            <CloseIcon onClick={() => closePopUp()} />
                        </div>
                    </div>
                    <div className={`${classes.redeemFormContainer}`}>
                        <FormProvider {...formMethods}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className={`${classes.formField}`}>
                                    <InputBox
                                        label={"Customer Email"}
                                        className={`w-[100%] ${classes.notesInput}`}
                                        name={"email"}
                                        placeholder={'Email'}
                                        {...register("email", {
                                            required: true,
                                            value : value,
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                message: "Invalid email address",
                                            },
                                        })}
                                        error={errors.email}
                                        messages={{
                                            required: "Email is required",
                                            pattern: "Invalid email address",
                                        }}
                                    />
                                </div>
                                <div className={`${classes.formField}`}>
                                    <InputBox
                                        label={"Subject"}
                                        className={`w-[100%] ${classes.notesInput}`}
                                        name={"subject"}
                                        {...register("subject", {
                                            required: true,
                                        })}
                                        placeholder={'Subject'}
                                        error={errors.subject}
                                        messages={{
                                            required: "Subject is required",
                                        }}
                                    />
                                </div>
                                <div className={`${classes.formField}`}>
                                    <InputBox
                                        label={"Title"}
                                        className={`w-[100%] ${classes.notesInput}`}
                                        name={"title"}
                                        {...register("title", {
                                            required: true,
                                        })}
                                        placeholder={'Title'}
                                        error={errors.subject}
                                        messages={{
                                            required: "Title is required",
                                        }}
                                    />
                                </div>
                                <div className={`${classes.formField}`}>
                                    <InputBox
                                        label={"Message"}
                                        className={`w-[100%] ${classes.notesInput}`}
                                        name={"message"}
                                        type={"textarea"}
                                        {...register("message", {
                                            required: true,
                                        })}
                                        placeholder={'Message'}
                                        error={errors.message}
                                        messages={{
                                            required: "Message is required",
                                        }}
                                    />
                                </div>
                                <div className='flex justify-end'>
                                    <Button text={"Send"} className={`w-[100%] my-4`} smallBtn />
                                </div>
                            </form>
                        </FormProvider>
                    </div>
                </div>
            </ModalDropdown>
        </>
    );
}

export default RedeemResponseModal